<div class="container">
    <div class="loading-overlay" *ngIf="loading">
        <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="3"></mat-progress-spinner>
      </div>
    <div class="card-form">
        <div class="blue-top"></div>
        <div class="card-section bottom-section">
            <iframe width='100%' height="100%" [src]="src"></iframe>
        </div>
    </div>
</div>

